<form class="row g-3" (ngSubmit)="salvarJornada()">
  <app-painel-dados-jornada
    class="row g-3"
    [empregadores]="empregadores"
    [empregadorSelecionado]="empregadorSelecionado"
    [jornada]="jornada"
    [jornadas]="jornadas"
    (empregadorSelecionadoChange)="selecionarEmpregador($event)"
    (jornadaChange)="jornada = $event"
    (jornadaSelecionada)="selecionarJornada($event)">
  </app-painel-dados-jornada>

  <app-grade-horarios-jornada
    [jornada]="jornada"
    (jornadaChange)="jornada = $event"
    (adicionarHorario)="adicionarHorario()"
    (removerHorario)="removerHorario($event)">
  </app-grade-horarios-jornada>

  <div class="col-12">
    <app-rodape-crud
      [exibirExcluir]="true"
      [excluirDesabilitado]="!jornada.id || jornada.padrao"
      (excluir)="excluirJornada()"
      (limpar)="limparJornada()"
      (salvar)="salvarJornada()">
    </app-rodape-crud>
  </div>
</form>

<app-grade-jornadas-relogio
  [jornadas]="jornadas"
  (selecionar)="selecionarJornada($event)">
</app-grade-jornadas-relogio>
